import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

interface FlatCardComponentProps {
  tariff: TariffModel;
}

export const FlatCardComponent = ({
  tariff,
}: FlatCardComponentProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // TODO: Should be moved in SDK
  const flatValue = useMemo(() => {
    const firstElement = tariff.elements[0];
    return firstElement?.price_components.find(
      (p) => p.type === TariffDimensionType.FLAT,
    )?.price;
  }, [tariff]);

  // TODO: Should be moved in SDK
  const description = useMemo(() => {
    if (!tariff.tariff_alt_text) {
      return undefined;
    }
    const concatenatedText = tariff.tariff_alt_text
      .reduce((acc: string[], text) => {
        if (i18n.language.startsWith(text.language)) {
          acc.push(text.text);
        }
        return acc;
      }, [])
      .join(', ');

    return concatenatedText === '' ? undefined : concatenatedText;
  }, [tariff]);

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.M} direction="column">
      <Stack gap={GapEnum.M} justifyContent="space-between" alignItems="center">
        <AccentTitle
          icon="home-03"
          text={t('$.emsp-bo-tariff-details.flat.title')}
          as={HeadingEnum.H2}
          variant={AccentVariantEnum.Secondary}
        />
        <Text bold>
          {flatValue !== undefined &&
            toCurrencyString(flatValue, tariff.currency)}
        </Text>
      </Stack>

      {description && (
        <Stack gap={GapEnum.S} direction="column">
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.tariff-alt-text',
            )}
          </Text>
          <Text>{description}</Text>
        </Stack>
      )}
    </Card>
  );
};
